import { SHAPES } from './generated/shapes.js';
import { cx } from './util.js';

export interface LoadingIndicatorProps {
  size?: number;
  /** Spoken label. Pass an empty string inside a control that already says it is busy. */
  label?: string;
  className?: string;
}

const KEYFRAMES = [
  'softburst',
  'cookie9',
  'clover4',
  'sunny',
  'flower',
  'puffy',
  'cookie6',
  'softburst',
] as const;

/**
 * The contained loading indicator: a shape that morphs while it turns. Motion is stopped for
 * people who ask for less; the shape then stays still and the label carries the meaning.
 */
export function LoadingIndicator({
  size = 48,
  label = 'Loading',
  className,
}: LoadingIndicatorProps) {
  const frames = KEYFRAMES.map(
    (name, i) =>
      `${Math.round((i / (KEYFRAMES.length - 1)) * 100)}%{clip-path:path('${SHAPES[name]}')}`,
  ).join('');
  return (
    <span
      className={cx('k-loading', className)}
      style={{ width: size, height: size }}
      {...(label === '' ? { 'aria-hidden': true } : { role: 'status', 'aria-label': label })}
    >
      <style>{`@keyframes k-morph{${frames}}`}</style>
      <span className="k-loading__shape" style={{ transform: `scale(${size / 96})` }} />
    </span>
  );
}
